import React, { ReactNode, useCallback, useState } from "react";
import { BodyTab, BtnTab, Container, TabsHeader } from "./styles";

interface TabProps {
  description: string;
  component: ReactNode;
  isDisable?: boolean;
}

interface HeaderTabProps {
  tabs: TabProps[];
  currentTab?: string;
  setTab?: (tab: string) => void;

  styleBody?: React.CSSProperties;
}

const TabComponent: React.FC<HeaderTabProps> = ({
  tabs,
  currentTab,
  setTab,
  styleBody,
}) => {
  const [activeIndex, setActiveIndex] = useState(0);

  const handleTabClick = useCallback(
    (description: string, index: number) => {
      setActiveIndex(index);
      if (!!setTab) setTab(description);
    },
    [setTab]
  );

  return (
    <Container>
      <TabsHeader>
        {tabs
          .filter((f) => f.isDisable !== true)
          .map((tab, index) => (
            <BtnTab
              type="button"
              key={tab.description}
              onClick={() => handleTabClick(tab.description, index)}
              isActive={
                !!currentTab
                  ? currentTab === tab.description
                  : index === activeIndex
              }
            >
              {tab.description}
            </BtnTab>
          ))}
      </TabsHeader>

      <BodyTab key={activeIndex} style={styleBody}>
        {!!currentTab
          ? tabs.find((f) => f.description === currentTab)?.component
          : tabs[activeIndex].component}
      </BodyTab>
    </Container>
  );
};

export const Tab = TabComponent;
